import { deleteCustomTemplate } from 'api/templates';
import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const DeleteConfirmation = ({ data, setShowDeleteModal }) => {

  const queryClient = useQueryClient();

  const { mutate: deleteTemplate, isLoading: deletingTemplate } = useMutation(
    (data) => deleteCustomTemplate(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customTemplates');
        toast.success('Template deleted');
        setShowDeleteModal(false);
      },
      onError: () => {
        toast.error('Failed to delete template');
      },
    }
  );

  return (
    <>
      <div className="text-xl text-center font-semibold my-10">
        <p>Are you sure you want to delete <span className='text-blue5'>{data.templateName}</span> template?</p>
        <p>This action cannot be undone.</p>
      </div>
      <div className="flex justify-center w-full">
        <div className="flex items-center gap-4">
          <button
            onClick={() => {
              deleteTemplate(data)
            }}
            disabled={deletingTemplate}
            className="bg-green px-8 py-2 rounded-lg border border-solid border-grey"
          >
            {!deletingTemplate ? 'Yes' : 'Deleting...'}
          </button>
          <button
            disabled={deletingTemplate}
            onClick={setShowDeleteModal}
            className="bg-red4 px-8 py-2 rounded-lg border border-solid border-grey"
          >
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteConfirmation;
